import { AbstractControl } from '@angular/forms';
import { NullActionTypes } from 'generated/graphql-types';
import { ExtensionOption } from '../../extension-register/models/extension-option.interface';

export function getNullActionPlaceholder(value?: NullActionTypes): string {
   switch (value) {
      case NullActionTypes.Hangup:
         return 'Hangup';
      case NullActionTypes.Directory:
         return 'Name Directory';
      case NullActionTypes.Voicemail:
         return 'Voicemail';
      case NullActionTypes.Unset:
         return '';
      default:
         return '';
   }
}

export function getNullActionTypeNumericValue(type: NullActionTypes): number {
   switch (type) {
      case NullActionTypes.Directory:
         return -1;
      case NullActionTypes.Hangup:
         return -2;
      case NullActionTypes.Voicemail:
         return -3;
      case NullActionTypes.Unset:
         return 0;
   }
}

export function setNullActionValue(
   value: ExtensionOption | null,
   lastValueRef: { current: ExtensionOption | null },
   extensionControl: AbstractControl | null,
   nullActionControl: AbstractControl | null,
   markAsDirty = true
): void {
   if (value?.extensionId == lastValueRef.current?.extensionId) {
      return;
   }
   lastValueRef.current = value;
   if (value?.extensionId === -1) {
      extensionControl?.setValue({ ...value, extensionId: null }, { emitEvent: false });
      nullActionControl?.setValue(NullActionTypes.Directory);
   } else if (value?.extensionId === -2) {
      extensionControl?.setValue({ ...value, extensionId: null }, { emitEvent: false });
      nullActionControl?.setValue(NullActionTypes.Hangup);
   } else if (value?.extensionId === -3) {
      extensionControl?.setValue({ ...value, extensionId: null }, { emitEvent: false });
      nullActionControl?.setValue(NullActionTypes.Voicemail);
   } else if (value?.extensionId === null && lastValueRef?.current?.extensionId === -1) {
      nullActionControl?.setValue(NullActionTypes.Unset);
   } else if (value?.extensionId && value?.extensionId >= 0) {
      nullActionControl?.setValue(NullActionTypes.Unset);
   }

   if (markAsDirty) {
      nullActionControl?.markAsDirty();
      nullActionControl?.updateValueAndValidity();
      extensionControl?.markAsDirty();
      extensionControl?.updateValueAndValidity();
   }
}
